import { render, staticRenderFns } from "./04.vue?vue&type=template&id=cb194516&scoped=true&"
import script from "./04.vue?vue&type=script&lang=js&"
export * from "./04.vue?vue&type=script&lang=js&"
import style0 from "./04.vue?vue&type=style&index=0&id=cb194516&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb194516",
  null
  
)

export default component.exports